import d3 from 'd3';
import geoSorter from '../sorters/geoSort';

/*
 * Set proper heights so spacing works
 */
export function heightizer(container, options) {
  let siblingAdjustment = 0;
  const legendRows = container.selectAll('g.legend-row');
  legendRows.each(function(d, idx) {
    const actingRow = d3.select(this);
    actingRow.attr(
      'transform',
      `translate(0, ${(idx !== 0) ? siblingAdjustment : 0})`
    );

    const legendItems = actingRow.selectAll('g.legend-item');
    legendItems.each(function() {
      const actingItem = d3.select(this);
      let childSiblingAdjustment = options.rowSpacing;
      childSiblingAdjustment += actingItem.select('.legend-text')
        .node()
        .getBBox()
        .height;
    });

    siblingAdjustment += actingRow.node().getBBox().height + options.rowSpacing;
  });
}

export function wrapText(texts, width, options) {
  texts.each(function() {
    const text = d3.select(this);
    // check if we even need to do wrapping
    if (text.node().getComputedTextLength() > width) {
      const words = text.text().split(/\s+/);
      let line = [];
      const lineHeight = 1.1; // ems
      const y = text.attr('y');
      const dy = parseFloat(text.attr('dy')) || 0;
      let tspan = text.text(null)
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', dy + 'em');

      words.forEach(function(word) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          text.attr(
            'transform',
            `translate(${options.textPadding.left}, ${options.textPadding.top})`
          );
          line.pop();
          tspan.text(line.join(' '));
          line = [word];
          tspan = text.append('tspan')
            .attr('x', 0)
            .attr('y', y)
            .attr('dy', lineHeight + dy + 'em')
            .text(word);
        }
      });
    }
  });
}

/**
 * Sorts the data and transforms it into:

 * [
 *   {
 *     'states': [
 *       {
 *         'state': 'Texas'
 *         'color': '#e7e7e7',
 *       },
 *       {..},
 *       {..},
 *     ]
 *   }, {
 *     'characteristic': [
 *       {
 *         'characteristic': 'Average GDP',
 *         'shape': 'circle',
 *       },
 *       {..},
 *       {..},
 *     ]
 *   }
 * ]
 *
 * *****************************
 * ** OR if generating for a map legend **
 * *****************************
 *
 * [
 *   {
 *     'states': [
 *       {
 *         'state': 'Texas'
 *         'color': '#e7e7e7',
 *         'characteristics': [
 *           {
 *             'characteristic': 'Average GDP',
 *             'shape': 'circle',
 *             'color': '#e7e7e7',
 *           },
 *           {..},
 *           {..},
 *         ],
 *       },
 *       {..},
 *       {..},
 *     ]
 *   }
 * ]
*/
export function buildData(data, options) {
  if (options.isMap) {
    return [{ 'states': _splitData(data, options.maxSplit) }];
  }

  const distributionsMap = data.reduce((acc, item) => {
    return angular.extend({}, acc, { [item.characteristic]: item.shape });
  }, {});
  const statesMap = data.reduce((acc, item) => {
    return angular.extend({}, acc, { [item.state]: item.color });
  }, {});

  const states = Object.keys(statesMap).map((val) => {
    return {
      state: val,
      color: statesMap[val],
    };
  }).sort((a, b) => geoSorter(
    a.state,
    b.state,
    {
      // Default header for geos...
      characteristic: 'Location',
      type: 'geography',
      'label': 'Geography',
      idx: 0,
    },
    false,
    a.state,
    b.state
  ));

  const distributions = Object.keys(distributionsMap).map((val) => {
    return {
      characteristic: val,
      shape: distributionsMap[val],
    };
  });

  return [{
    states: _splitData(states, options.maxSplit),
    distributions: _splitData(distributions, options.maxSplit),
  }];
}

/* Converts Array into 2d array
 * w/ split = 2...
 * [1,2,3,4,5]
 * to
 * [[1,2],[3,4],[5]]
 */
function _splitData(data, split = 0) {
  const newArray = [];
  for (let i = 0; i < data.length; i += split) {
    newArray.push(data.slice(i, i + split));
  }
  return newArray;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/util/d3.legend/util.js
 **/